// FormPage.js
import React, { useState } from "react";
import CardWithLogo from "./CardWithLogo";
import PlanosInfoStep from "./steps/PlanosInfoStep";

const FormPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const totalSteps = 5;

  const handleNext = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    if (currentStep < totalSteps) {
      setCurrentStep((prev) => prev + 1);
    } else {
      handleSubmitForm();
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleSubmitForm = async () => {
    try {
      const response = await createLead(formData);
      console.log(response);
      alert("Lead criado com sucesso!");
    } catch (error) {
      console.error("Erro ao criar lead:", error);
      alert("Erro ao criar lead");
    }
  };

  return (
    <div className="min-h-screen bg-[#F2F3F7] flex justify-center items-start px-4 pt-16">
      {currentStep === 5 ? (
        <PlanosInfoStep onBack={handleBack} />
      ) : (
        <CardWithLogo
          currentStep={currentStep}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      )}
    </div>
  );
};

const createLead = async (data) => {
  const response = await fetch("URL_DA_SUA_API", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error();
  return response.json();
};

export default FormPage;
